import { Post } from "api";
import { call, put, takeEvery } from "redux-saga/effects";
import {
  RequestFailedUpdate,
  RequestLoadingUpdate,
  RequestSuccessfulUpdate,
} from "request";
import { UpdatePartners, UpdatePartnersRequestStateAction } from "./action";

export function* partnersSaga() {
  yield takeEvery("partners-request-partners", fetchPartners);
}

function* fetchPartners(action: any) {
  try {
    yield put(UpdatePartnersRequestStateAction(RequestLoadingUpdate));
    //@ts-ignore
    const response: any = yield call(Post, "/manage/partners", {
      limit: action.limit,
      offset: action.offset - 1,
      filters: {
        ...action.filters,
      },
    });

    yield put(UpdatePartners(response.partnerList, response.resultCount));
    /* yield put(
      UpdatePartners(
        MOCK_PARTNERS.slice(
          (action.offset - 1) * action.limit,
          ((action.offset - 1) * action.limit) + action.limit
        ),
        MOCK_PARTNERS.length
      )
    ); */
    yield put(UpdatePartnersRequestStateAction(RequestSuccessfulUpdate));
  } catch (e) {
    console.warn(e);
    yield put(UpdatePartnersRequestStateAction(RequestFailedUpdate));
  }
}